The success result for the `postPositionProfileForOpening` mutation.
